import { defineMessages } from 'react-intl';

export default defineMessages({
  branchLabel: {
    id: 'frontbucket.repository.pullRequest.branchLabel',
    description: 'Aria label for branch  in the header',
    defaultMessage: 'Branch: {branchName}',
  },
  changeDestinationBranchLabel: {
    id: 'frontbucket.repository.pullRequest.changeDestinationBranchLabel',
    description: 'Aria label for destination branch change button',
    defaultMessage: 'Change destination branch',
  },
});
